import { render, staticRenderFns } from "./AlertDistribution.vue?vue&type=template&id=0e2d35c8&"
import script from "./AlertDistribution.vue?vue&type=script&lang=js&"
export * from "./AlertDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports